module.exports = __webpack_public_path__ + "static/img/tkjl.7e5c012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tkjl.png
// module id = SVg/
// module chunks = 1